import { FileText, Image as ImageIcon, PlayCircle, Trash2 } from "lucide-react";
import { absolute } from "../../../lib/share";

const TYPE = { pdf: ["PDF", FileText], video: ["Video", PlayCircle], image: ["Imagen", ImageIcon] };

export const MaterialThumb = ({ item, className = "" }) => {
  const [, Icon] = TYPE[item.type] || TYPE.pdf;
  if (item.type === "video" && !item.thumbnail) return <video src={absolute(item.url)} preload="metadata" muted className={`h-full w-full object-cover ${className}`} />;
  if (item.thumbnail) return <img src={absolute(item.thumbnail)} alt="" loading="lazy" className={`h-full w-full object-cover ${className}`} />;
  return <div className={`grid h-full w-full place-items-center bg-ink text-leaf ${className}`}><Icon className="h-10 w-10" /></div>;
};

/** Paso 2 · galería de materiales. onPick abre el paso de compartir. */
export const MaterialGrid = ({ items, clicks = {}, selected, onPick, onDelete, testPrefix = "mat" }) => (
  <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-testid={`${testPrefix}-grid`}>
    {items.map((item, i) => {
      const [label] = TYPE[item.type] || TYPE.pdf;
      const active = selected?.slug === item.slug;
      return (
        <article key={item.slug} className={`group flex flex-col overflow-hidden rounded-[1.25rem] border bg-white transition-[border-color,transform] duration-300 hover:-translate-y-0.5 ${active ? "border-leaf ring-2 ring-leaf/40" : "border-ink/10"}`} data-testid={`${testPrefix}-${i}`}>
          <button type="button" onClick={() => onPick(item)} className={`relative block w-full overflow-hidden bg-ink ${item.type === "image" && item.url.includes("historia") ? "aspect-[9/12]" : "aspect-video"}`} data-testid={`${testPrefix}-pick-${i}`}>
            <MaterialThumb item={item} className="transition-transform duration-500 group-hover:scale-[1.03]" />
            <span className="absolute left-3 top-3 rounded-full bg-ink/80 px-2.5 py-1 font-mono text-[10px] font-semibold uppercase tracking-[0.1em] text-white backdrop-blur">{label}</span>
            {clicks[item.slug] > 0 && <span className="absolute right-3 top-3 rounded-full bg-leaf px-2.5 py-1 text-[10px] font-bold text-ink" data-testid={`${testPrefix}-clicks-${i}`}>{clicks[item.slug]} clics</span>}
          </button>
          <div className="flex flex-1 flex-col p-4">
            <h4 className="font-display text-base font-semibold leading-tight">{item.title}</h4>
            <p className="mt-1 flex-1 text-xs text-ink/60">{item.description}</p>
            <div className="mt-3 flex items-center gap-2">
              <button type="button" onClick={() => onPick(item)} className="btn-leaf !px-4 !py-2 !text-xs" data-testid={`${testPrefix}-share-${i}`}>Compartir</button>
              {onDelete && <button type="button" onClick={() => onDelete(item)} className="ml-auto rounded-full p-2 text-ink/50 hover:bg-coral/10 hover:text-coral" aria-label="Eliminar" data-testid={`${testPrefix}-delete-${i}`}><Trash2 className="h-4 w-4" /></button>}
            </div>
          </div>
        </article>
      );
    })}
  </div>
);
